import { DefaultValues } from 'react-hook-form'
import { boolean, InferType, MixedSchema, number, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'
import { softEnum } from 'directFlow/utils'

import { VehicleFuelType, VehicleSteering, VehicleTransmission, VehicleType } from 'types'

export const vehicleFoundPageDefaultValues = {
  abiCode: undefined,
  bodyType: undefined,
  description: undefined,
  firstRegistrationDate: undefined,
  groupRating: undefined,
  regPlate: undefined,
  price: undefined,
  year: undefined,
  fuel: undefined,
  tracker: undefined,
  transmission: undefined,
  groupedTransmission: undefined,
  engineSize: undefined,
  import: undefined,
  numberOfSeats: undefined,
  make: undefined,
  grossWeight: undefined,
  model: undefined,
  vehicleType: undefined,
  steering: undefined,
} satisfies DefaultValues<VehicleFoundSchemaType>

export const vehicleFoundPageSchema = object({
  regPlate: string().optional(),
  steering: softEnum(VehicleSteering, 'steering').required(
    requiredMessage,
  ) as MixedSchema<VehicleSteering>,
  abiCode: string().required(requiredMessage),
  bodyType: string().nullable(),
  description: string().required(requiredMessage),
  firstRegistrationDate: string().required(requiredMessage),
  groupRating: number().nullable(),
  price: number().required(requiredMessage),
  year: number().required(requiredMessage),
  fuel: softEnum(VehicleFuelType, 'fuel').required(requiredMessage) as MixedSchema<VehicleFuelType>,
  tracker: boolean().required(requiredMessage),
  transmission: softEnum(VehicleTransmission, 'transmission').required(
    requiredMessage,
  ) as MixedSchema<VehicleTransmission>,
  groupedTransmission: string().nullable(),
  engineSize: number()
    .nullable()
    .when(['fuel'], {
      is: VehicleFuelType.ELECTRIC,
      then: () => number().nullable(),
      otherwise: () => number().required(requiredMessage),
    }),
  import: boolean().required(requiredMessage),
  numberOfSeats: number().required(requiredMessage),
  grossWeight: number().nullable(),
  make: string().required(requiredMessage),
  model: string().required(requiredMessage),
  vehicleType: softEnum(VehicleType, 'vehicleType').required(
    requiredMessage,
  ) as MixedSchema<VehicleType>,
}).required(requiredMessage)

export type VehicleFoundSchemaType = InferType<typeof vehicleFoundPageSchema>
